import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

export function SignInPage({ allowedDomain }: { allowedDomain: string }): ReactNode {
  const [params] = useSearchParams();
  const reason = params.get('reason');
  const email = params.get('email');

  const message =
    reason === 'forbidden'
      ? `${email ?? 'That Google account'} is not a @${allowedDomain} address, so it cannot use this platform.`
      : reason === 'denied'
        ? 'Google sign-in did not complete. Try again, and use your work account.'
        : reason === 'unavailable'
          ? 'Google sign-in is not configured on this server yet.'
          : undefined;

  return (
    <div className="signin">
      <div className="signin__card">
        <p className="signin__brand">sfpbxtestbot</p>
        <h1>Sign in to run RocketPhone checks</h1>
        <p className="signin__lede">
          This site is open on the internet. Sign in with your RocketPhone Google account so only
          the team can start runs, read reports, or change credentials.
        </p>
        {message ? <p className="signin__error">{message}</p> : null}
        <a className="button button--primary" href="/api/auth/google">
          Sign in with Google
        </a>
        <p className="muted">Only @{allowedDomain} addresses are allowed.</p>
      </div>
    </div>
  );
}
